export const ProductDocumentsAttachmentRender = (props: any) =>
    <a href={'/gridApi/projectdocument/download/' + props.data.projectno + '/' + props.data.activityno + '/' + props.value}
       target="_blank" rel="noreferrer">
        {props.value}
    </a>